import { MonitoringMetricType } from './monitoringTypes';
import { millisecondsInMinute, millisecondsInHour } from 'date-fns/constants';

export const rangeType = {
  '1h': '1 hour',
  '3h': '3 hour',
  '6h': '6 hour',
  '12h': '12 hour',
  '24h': '24 hour',
  Custom: 'Custom',
};

export type MonitoringMetricTogglerType = MonitoringMetricType | 'ALL';

export type MetricToggleButtonOptionsType = {
  [key in MonitoringMetricTogglerType]: string;
};

export const MetricToggleButtonOptions: MetricToggleButtonOptionsType = {
  ALL: 'All',
  NODE: 'OS Metrics',
  DB: 'DB Metrics',
};

export enum GranularityEnum {
  '1m' = '1m',
  '5m' = '5m',
  '15m' = '15m',
  '30m' = '30m',
  '1h' = '1h',
  '6h' = '6h',
  '12h' = '12h',
  '1d' = '1d',
}

export enum ViewAsEnum {
  AVG = 'AVG',
  MIN = 'MIN',
  MAX = 'MAX',
}

export const DEFAULT_VIEW_AS = ViewAsEnum.AVG;

export interface ViewAsOption {
  value: ViewAsEnum;
  label: string;
}

export const VIEW_AS_OPTIONS: ViewAsOption[] = [
  { value: ViewAsEnum.AVG, label: 'Avg' },
  { value: ViewAsEnum.MIN, label: 'Min' },
  { value: ViewAsEnum.MAX, label: 'Max' },
];

export type GranularityConfigValue = {
  value: number;
  displayLabel: string;
  id: GranularityEnum;
};

export const GranularityEnumConfig: Record<
  GranularityEnum,
  GranularityConfigValue
> = {
  '1m': {
    value: millisecondsInMinute,
    displayLabel: '1 Mins',
    id: GranularityEnum['1m'],
  },
  '5m': {
    value: millisecondsInMinute * 5,
    displayLabel: '5 Mins',
    id: GranularityEnum['5m'],
  },
  '15m': {
    value: millisecondsInMinute * 15,
    displayLabel: '15 Mins',
    id: GranularityEnum['15m'],
  },
  '30m': {
    value: millisecondsInMinute * 30,
    displayLabel: '30 Mins',
    id: GranularityEnum['30m'],
  },
  '1h': {
    value: millisecondsInHour,
    displayLabel: '1 Hour',
    id: GranularityEnum['1h'],
  },
  '6h': {
    value: millisecondsInHour * 6,
    displayLabel: '6 Hours',
    id: GranularityEnum['6h'],
  },
  '12h': {
    value: millisecondsInHour * 12,
    displayLabel: '12 Hours',
    id: GranularityEnum['12h'],
  },
  '1d': {
    value: millisecondsInHour * 24,
    displayLabel: '1 Day',
    id: GranularityEnum['1d'],
  },
};
